module.exports = {
	"_from": "videojs-swf@5.4.1",
	"_id": "videojs-swf@5.4.1",
	"_inBundle": false,
	"_integrity": "sha1-IHfvccdJ8seCPvSbq65N0qywj4c=",
	"_location": "/videojs-swf",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "videojs-swf@5.4.1",
		"name": "videojs-swf",
		"escapedName": "videojs-swf",
		"rawSpec": "5.4.1",
		"saveSpec": null,
		"fetchSpec": "5.4.1"
	},
	"_requiredBy": [
		"/videojs-flash"
	],
	"_resolved": "http://registry.npm.taobao.org/videojs-swf/download/videojs-swf-5.4.1.tgz",
	"_shasum": "2077ef71c749f2c7823ef49babae4dd2acb08f87",
	"_spec": "videojs-swf@5.4.1",
	"_where": "/Users/stonemaker/Documents/coding/yaopai-live/node_modules/videojs-flash",
	"author": {
		"name": "Brightcove"
	},
	"bugs": {
		"url": "https://github.com/videojs/video-js-swf/issues"
	},
	"bundleDependencies": false,
	"copyright": "Copyright 2014 Brightcove, Inc. https://github.com/videojs/video-js-swf/blob/master/LICENSE",
	"deprecated": false,
	"description": "The Flash-fallback video player for video.js (http://videojs.com)",
	"devDependencies": {
		"async": "~0.2.9",
		"chg": "^0.3.2",
		"flex-sdk": "4.6.0-0",
		"grunt": "~0.4.0",
		"grunt-bumpup": "~0.5.0",
		"grunt-cli": "~0.1.0",
		"grunt-connect": "~0.2.0",
		"grunt-contrib-jshint": "~0.4.3",
		"grunt-contrib-qunit": "~0.2.1",
		"grunt-contrib-watch": "~0.1.4",
		"grunt-npm": "~0.0.2",
		"grunt-prompt": "~0.1.2",
		"grunt-shell": "~0.6.1",
		"grunt-tagrelease": "~0.3.1",
		"qunitjs": "~1.12.0",
		"video.js": "^5.9.2"
	},
	"homepage": "http://videojs.com",
	"keywords": [
		"flash",
		"video",
		"player"
	],
	"name": "videojs-swf",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/videojs/video-js-swf.git"
	},
	"scripts": {
		"version": "chg release -y && grunt dist && git add -f dist/ && git add CHANGELOG.md"
	},
	"version": "5.4.1"
};


//////////////////
// WEBPACK FOOTER
// ./~/videojs-swf/package.json
// module id = 487
// module chunks = 1